<!--
 * @Author: ZhengXiaowei
 * @Date: 2019-01-09 14:06:31
 * @LastEditors: 晓晓晓晓晓丶vv
 * @LastEditTime: 2020-04-03 10:49:17
 * @Description: 登录页面
 -->
<template>
  <x-page class="login-page">
    <div class="x-login">
      <div class="login-logo">
        <img src="../assets/yc.png" alt="" />
      </div>
      <div class="x-login__tab">
        <div
          class="x-login__tab--item"
          :class="{ active: tab === 'account' }"
          @click="tab = 'account'"
        >
          账号登录
        </div>
        <div
          class="x-login__tab--item"
          :class="{ active: tab === 'code' }"
          @click="tab = 'code'"
        >
          验证码登录
        </div>
      </div>
      <div class="x-login__form">
        <template v-if="tab === 'account'">
          <div class="form-item">
            <input
              type="text"
              placeholder="请输入账号或邮箱"
              v-model="form.account"
            />
          </div>
          <div class="form-item">
            <input
              type="password"
              placeholder="请输入密码"
              v-model="form.password"
            />
          </div>
          <div class="form-item">
            <input type="text" placeholder="验证码" v-model="form.captcha" />
            <img :src="code" alt="" class="form-code" @click="updateCode" />
          </div>
        </template>
        <template v-if="tab === 'code'">
          <div class="form-item">
            <input
              type="number"
              placeholder="请输入手机号"
              v-model="form.phone"
            />
          </div>
          <div class="form-item">
            <input type="text" placeholder="请输入验证码" v-model="form.code" />
            <p
              class="login-count"
              @click="sendCode"
              :class="[isSending ? 'is-sending' : '']"
            >
              {{ sendButtonText }}
            </p>
          </div>
        </template>
      </div>

      <div class="x-login__btn" @click="login">登录</div>
      <p class="login-tips" v-if="tab == 'code'">未注册用户登录即完成注册</p>
      <div class="x-login__thirdapp">
        <van-divider>第三方登录</van-divider>
        <div class="x-login__third">
          <template v-for="(t, i) in type">
            <div class="type-item" :key="i" @click="thirdLogin(t)">
              <img :src="t.logo_url" :alt="t.nickname" />
            </div>
          </template>
        </div>
      </div>
      <!--    <p class="small-title">- 第三方账号免费登录 -</p>
      <div class="x-login__box">
        <img class="login_banner"
             src="../assets/login_tiao.png"
             alt="">
        <div class="x-login__third">
          <template v-for="(t, i) in type">
            <div class="type-item"
                 :key="i"
                 @click="thirdLogin(t)">
              <img :src="t.logo_url"
                   :alt="t.nickname">
              <p>{{t.nickname}}</p>
            </div>
          </template>
        </div>
      </div>
      <p class="small-title">- 已有账号登录 -</p>
      <div class="x-login__account x-login__box">
        <div class="form-item">
          <input type="text"
                 placeholder="账户/邮箱"
                 v-model="form.account">
        </div>
        <div class="form-item">
          <input type="password"
                 placeholder="登录密码"
                 v-model="form.password">
        </div>
        <div class="form-item">
          <input type="text"
                 placeholder="验证码"
                 v-model="form.captcha">
          <img :src="code"
               alt=""
               @click="updateCode">
        </div>
        <p class="account-login"
           @click="login">登录</p>
      </div>
      <div class="x-login__tips x-login__box">
        <p class="title">登录有问题，请尝试：</p>
        <p class="tips-item">1、刷新页面重试一下；</p>
        <p class="tips-item">2、清除浏览器Cookie，再次登录</p>
      </div> -->
    </div>
  </x-page>
</template>

<script>
// TODO 接口跨域问题 以及验证码地址
import { Login, sendCodeApi, phoneLogin } from "@/api";
import { cookie } from "../utils";

import qs from "qs";

export default {
  data() {
    return {
      form: {
        account: "",
        password: "",
        captcha: "",
        phone: "",
        code: "",
        distribution_channel_id: window.ycsd.distribution_channel_id,
      },
      tab: "account",
      type: window.ycsd.login_config.login_config,
      redirect_base_domain: window.ycsd.login_config.base_domain,
      code: window.ycsd.account_get_capture_url,
      time: 60,
      timeId: null,
      isSending: false,
      sendButtonText: "获取验证码",
    };
  },
  computed: {
    isDisabled() {
      const regex = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
      // 可以添加手机号格式验证逻辑
      return this.form.phone == "" || !regex.test(this.form.phone);
    },
  },
  methods: {
    login() {
      if (this.tab == "account") {
        this.accountLogin();
      } else {
        if (this.isDisabled) {
          return this.$toast("请输入正确的手机号");
        }
        if (!this.form.code) {
          return this.$toast("请输入验证码");
        }
        
        this.codeLogin();
      }
    },
    sendCode() {
      if (this.isSending) return;

      if (this.isDisabled) {
        return this.$toast("请输入正确的手机号");
      }
      let data = {
        type: "login",
        phone: this.form.phone,
      };
      sendCodeApi(data)
        .then((res) => {
          this.isSending = true;
          this.timeId = setInterval(() => {
            //倒计时结束清楚倒计时
            if (this.time <= 0) {
              clearInterval(this.timeId);
              this.isSending = false;
              this.sendButtonText = "获取验证码";
              this.time = 60;
            } else {
              this.sendButtonText = this.time + "s后重新获取";
              this.time--;
            }
          }, 1000);
        })
        .catch((e) => {
          console.log(e, "222");
          this.$toast(e.msg || "操作繁忙");
        });
    },
    accountLogin() {
      this.$toast({
        type: "loading",
        message: "登录中...",
        forbidClick: true,
        duration: 0,
      });
      this.form.redirect_url = this.$route.query.redirect || "/";
      console.log(this.form.redirect_url);
      Login(JSON.stringify(this.form))
        .then((r) => {
          // this.$store.commit("system/SET_BROWER_TYPE", r.browerType);
          this.countDown().then(() => {
            let re = this.$route;
            // * 使用replace会替换当前的history 导致上层的页面需要点两次才能back
            // this.$router.replace(re.query.redirect);
            // * 暂时使用go(-1)方式返回
            // this.$router.go(-1);
            // this.$router.replace(r.redirect_url);
            location.href = r.redirect_url;
          });
        })
        .catch((e) => {
          this.updateCode();
          this.$toast({
            type: "fail",
            message: e.msg,
            forbidClick: true,
          });
        });
    },
    codeLogin() {
      this.$toast({
        type: "loading",
        message: "登录中...",
        forbidClick: true,
        duration: 0,
      });
      this.form.redirect_url = this.$route.query.redirect || "/";
      console.log(this.form.redirect_url);

      phoneLogin(JSON.stringify(this.form))
        .then((r) => {
          // this.$store.commit("system/SET_BROWER_TYPE", r.browerType);
          this.countDown().then(() => {
            let re = this.$route;
            // * 使用replace会替换当前的history 导致上层的页面需要点两次才能back
            // this.$router.replace(re.query.redirect);
            // * 暂时使用go(-1)方式返回
            // this.$router.go(-1);
            // this.$router.replace(r.redirect_url);
            location.href = r.redirect_url;
          });
        })
        .catch((e) => {
          this.updateCode();
          this.$toast({
            type: "fail",
            message: e.msg,
            forbidClick: true,
          });
        });
    },
    countDown() {
      return new Promise((resolve) => {
        let second = 3;
        let c = this.$toast({
          type: "success",
          loadingType: "spinner",
          message: "3秒后返回",
          forbidClick: true,
          duration: 0,
        });
        this.timer = setInterval(() => {
          second--;
          if (second) c.message = `${second}秒后返回`;
          else {
            clearInterval(this.timer);
            c.clear();
            resolve();
          }
        }, 1000);
      });
    },
    updateCode() {
      this.code = `${window.ycsd.account_get_capture_url}?r=${Math.random()}`;
    },
    thirdLogin(third) {
      let redirect = "";
      const queryRedirect = this.$route.query.redirect;
      if (queryRedirect.indexOf("?") !== -1)
        redirect = queryRedirect + "&base_domain=" + this.redirect_base_domain;
      else
        redirect = queryRedirect + "?base_domain=" + this.redirect_base_domain;
      let query = qs.stringify({
        distribution_channel_id: this.form.distribution_channel_id,
        is_mobile: 1,
        redirect_url: redirect,
        send_order_id: cookie.getCookie("send_order_id") || "",
      });
      location.href = third.redirect_url + "?" + query;
    },
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = false;
    next();
  },
};
</script>
